import { authAxios } from "services";

// eslint-disable-next-line import/prefer-default-export
export const fetchAll = (showroomId, page) =>
  authAxios().get(`/showrooms/${showroomId}/call-requests?page=${page}`);
